module.exports = __webpack_public_path__ + "static/media/HaloSplash2.be0a5ec7.jpg";